import { Fade, Modal, Stack } from '@mui/material';
import { FC, Fragment, memo } from 'react';

import { VpFallback } from '@vp/common/ui/component/VpFallback';
import { useViewModel } from '@vp/common/ui/hook/useViewModel';
import { ProfileModel } from '@vp/profile/core/model/ProfileModel';
import { ProfileAccess } from '@vp/profile/ui/access/ProfileAccess';
import { ProfileActivationPage } from '@vp/profile/ui/activation/ProfileActivationPage';
import { ProfileGatewayViewModel } from '@vp/profile/ui/gateway/ProfileGatewayViewModel';
import { ProfilePage } from '@vp/profile/ui/ProfilePage';

export const ProfileGateway: FC = () => {
  const viewModel = useViewModel(ProfileGatewayViewModel);
  const success = viewModel.state.value === 'success';
  const error = viewModel.state.value === 'error';

  if (viewModel.state.value === 'loading') {
    return null;
  }

  return (
    <Fragment>
      {error && <VpFallback title="Что-то пошло не так" text="Вероятно, возникла техническая проблема или профиль не найден" showRefresh />}

      {success && viewModel.profile.value.active && (
        <RestrictedProfile
          showRestriction={viewModel.showRestriction.value}
          isUnlocked={viewModel.isUnlocked.value}
          onProfileUnlock={viewModel.onProfileUnlock}
        />
      )}

      {success && !viewModel.profile.value.active && <ProfileActivationPage />}
    </Fragment>
  );
};

type RestrictedProfileProps = {
  showRestriction: boolean;
  isUnlocked: boolean;
  onProfileUnlock: (profile: ProfileModel) => void;
};

const RestrictedProfile = memo<RestrictedProfileProps>(({ showRestriction, isUnlocked, onProfileUnlock }) => {
  return (
    <Fragment>
      <ProfilePage />

      <Modal open={showRestriction} hideBackdrop aria-modal sx={theme => ({ zIndex: theme.zIndex.accessModal })}>
        <Fade in={showRestriction} timeout={500} easing="ease-in-out">
          <Stack
            sx={theme => ({
              width: 1,
              height: 1,
              backgroundColor: 'background.300',
              outline: 'none',
              [theme.breakpoints.only('mobile')]: {
                px: 3,
                pt: 17.5,
              },
              [theme.breakpoints.up('tablet')]: {
                justifyContent: 'center',
                alignItems: 'center',
              },
            })}
          >
            <ProfileAccess isUnlocked={isUnlocked} onProfileUnlock={onProfileUnlock} />
          </Stack>
        </Fade>
      </Modal>
    </Fragment>
  );
});

RestrictedProfile.displayName = 'RestrictedProfile';
